// extracted by mini-css-extract-plugin
module.exports = {"container":"_dc69e7c4","fraction":"_c54cfd09"};